import { Card, CardBody, Col, Form, Input, Label } from "reactstrap";
import { BorderRightText1, BorderRights, EmailAddress, EmailAddressPlaceHolders } from "../../../../Constant";
import { BORDER_RIGHT } from "../../../../Data/Bonus Ui/CreativeCard";
import CommonCreativeCardHeader from "../Common/CommonCreativeCardHeader";
import { P } from "../../../../AbstractElements";

const BorderRight = () => {
  return (
    <Col sm="12" md="6">
      <Card>
        <CommonCreativeCardHeader headerClass="border-r-secondary border-3" title={BorderRights} span={BORDER_RIGHT} />
        <CardBody>
          <P>{BorderRightText1}</P>
          <Form>
            <Label>{EmailAddress}</Label>
            <Input type="email" placeholder={EmailAddressPlaceHolders} />
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BorderRight;
